import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-standard-footer-buttons',
  templateUrl: './standard-footer-buttons.component.html',
  styleUrls: ['./standard-footer-buttons.component.scss'],
})
export class StandardFooterButtonsComponent {

  @Input() secondaryLabel: string = 'Cancelar';
  @Input() primaryLabel: string = 'Confirmar';
  @Input() isPrimaryDisabled: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() showSecondary: boolean = true;
  @Input() hidePrimary: boolean = false;
  @Input() isPrimaryDanger: boolean = false;
  @Output() secondaryClick = new EventEmitter<void>();
  @Output() primaryClick = new EventEmitter<void>();

  constructor() {}

  onSecondaryClick(): void {
    this.secondaryClick.emit();
  }

  onPrimaryClick(): void {
    this.primaryClick.emit();
  }
}
